export default __webpack_public_path__ + "static/media/iDocFont-20.1ef83d94.svg";